import { render, staticRenderFns } from "./SingleValue.vue?vue&type=template&id=6eb2295c&scoped=true&"
import script from "./SingleValue.vue?vue&type=script&lang=js&"
export * from "./SingleValue.vue?vue&type=script&lang=js&"
import style0 from "./SingleValue.vue?vue&type=style&index=0&id=6eb2295c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb2295c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb2295c')) {
      api.createRecord('6eb2295c', component.options)
    } else {
      api.reload('6eb2295c', component.options)
    }
    module.hot.accept("./SingleValue.vue?vue&type=template&id=6eb2295c&scoped=true&", function () {
      api.rerender('6eb2295c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/widgets/SingleValue.vue"
export default component.exports